export const environment = {
  production: true,
  BASE_EMAIL_SERVICOS_API_URL2: '',
  HASH: 'aguaevida',
  KEYCLOAK_URL: 'https://watergate.casan.com.br',
  KEYCLOAK_REALM: 'domo',
  KEYCLOAK_CLIENT_ID: 'atendimento-distancia-publico'
};
